export default "__VITE_ASSET__DGjy3xyo__"